import { defineMessages } from 'react-intl';

export default defineMessages({
    /**
     * Messages shown on the Modal when a user triggers a detailed policy search
     */
    searchForYourPolicy: {
        id: 'fnol.producer.common.views.policy-select-producer.Search for your policy',
        defaultMessage: 'Search for your policy'
    },
    searchPolicy: {
        id: 'fnol.producer.common.views.policy-select-producer.Search Policy',
        defaultMessage: 'Search Policy'
    },
    cancelPolicySearch: {
        id: 'fnol.producer.common.views.policy-select-producer.Cancel',
        defaultMessage: 'Cancel'
    },
    /**
     * ViewModelForm Messages
     */
    selectPolicyFirstName: {
        id: 'fnol.producer.common.views.policy-select-producer.First Name',
        defaultMessage: 'First Name'
    },
    selectPolicyLastName: {
        id: 'fnol.producer.common.views.policy-select-producer.Last Name',
        defaultMessage: 'Last Name'
    },
    selectPolicyCity: {
        id: 'fnol.producer.common.views.policy-select-producer.City',
        defaultMessage: 'City'
    },
    selectPolicyState: {
        id: 'fnol.producer.common.views.policy-select-producer.State',
        defaultMessage: 'State'
    },
    selectPolicyPolicyType: {
        id: 'fnol.producer.common.views.policy-select-producer.Policy Type',
        defaultMessage: 'Policy Type'
    },
    selectPolicyZipCode: {
        id: 'fnol.producer.common.views.policy-select-producer.Zip Code',
        defaultMessage: 'Zip Code'
    }
});
